import {
  Card,
  Flex,
  Loading,
  NotFound,
  PageContent,
  PageHeader,
  PageTitle,
  Space,
} from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { useMe } from '@/features/authentication/_hooks/me';
import { useGroup } from '@/features/project/groups/_hooks/group';
import { useChangeBrowserTabTitleEffect, useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupActionsButton } from '../_components/GroupActionsButton';
import { ProjectsTable } from '../_components/ProjectsTable';
import { GroupInProjects } from '../_components/group-in-projects/GroupInProjects';

export const ProjectGroupPage: FC = () => {
  const { id } = useId();
  const { t } = useTranslation();
  const me = useMe();
  const group = useGroup(id, { projectIds: true });

  const editPermission =
    (group.data &&
      me.data?.organizationIds.includes(group.data.organizationId)) ??
    false;

  useChangeBrowserTabTitleEffect({ title: group.data?.name });

  if (group.isError) {
    return <NotFound backRoute="/rs/project/group" />;
  }
  if (group.isPending || !group.data) {
    return <Loading />;
  }
  return (
    <>
      <PageHeader
        title={<PageTitle text={group.data?.name ?? ''} />}
        breadcrumbs={[
          {
            title: t('projects-page'),
            href: '/rs/project/group',
          },
          { title: t('project-group-page') },
        ]}
        buttons={
          <ProjectResourceGuard>
            <Space>
              <GroupActionsButton />
            </Space>
          </ProjectResourceGuard>
        }
      />
      <PageContent>
        <Flex vertical gap={24}>
          <Card>
            <GroupInProjects editPermission={editPermission} />
          </Card>
          {editPermission && (
            <Card>
              <ProjectsTable
                groupFiscalYear={group.data.fiscalYear.toString()}
                groupInProjectIds={group.data.groupTargets.flatMap(
                  (v) => v.objectId,
                )}
              />
            </Card>
          )}
        </Flex>
      </PageContent>
    </>
  );
};
